export default "__VITE_ASSET__3f471c3f__"